import * as amplitude from '@amplitude/analytics-browser'

const page = '/valuation'
const trackPage = '/track'

// Amplitude가 초기화된 후에 호출해야 함
export function getDeviceId() {
  return amplitude.getDeviceId()
}

export const amplitudeEvent = {
  CLICK_PREPAID: () => {
    _track('Click prepaid', { page })
  },
  CLICK_DETAIL_VALUATION: () => {
    _track('Click detail valuation', { page })
  },
  CLICK_EVERAGE_YEAR: year => {
    _track('Click everage year', { page, year })
  },
  ENTER_DIRECTLY: () => {
    _track('Enter directly', { page })
  },
  ENTER_DIRECTLY_COMPLITE: ({ profit, type }) => {
    _track('Enter directly complite', { page, profit, type })
  },
  SLIDE: ({ profit }) => {
    _track('slide', { page, profit })
  },

  // 트랙 페이지
  TRACK_PAGE: option => {
    _track('ACCESS_TRACK_PAGE', { ...option })
  },
  // 멜론에서 음악 감상하기 팝업: 아니오
  TRACK_MELON_POPUP_CANCEL: () => {
    _track('TRACK_MELON_POPUP_CANCEL', {})
  },
  // 멜론에서 음악 감상하기 팝업: 네
  TRACK_MELON_POPUP_CONFIRM: () => {
    _track('TRACK_MELON_POPUP_CONFIRM', {})
  },
  // 트랙 헤더 뒤로가기 클릭
  TRACK_HEADER_BACK: () => {
    _track('TRACK_HEADER_BACK', {})
  },
  // 트랙 헤더 옵션 클릭
  TRACK_HEADER_OPTION: option => {
    _track('TRACK_HEADER_OPTION', { ...option })
  },
  // 트랙 헤더 공유 클릭
  TRACK_HEADER_SHARE: option => {
    _track('TRACK_HEADER_SHARE', { ...option })
  },
  // 트랙 헤더 좋아요 클릭
  TRACK_HEADER_FAVORITE: option => {
    _track('TRACK_HEADER_FAVORITE', { ...option })
  },
  // 트랙 헤더 아티스트 클릭
  TRACK_HEADER_ARTIST: option => {
    _track('TRACK_HEADER_ARTIST', { ...option })
  },
  // 트랙 헤더 앨범 클릭
  TRACK_HEADER_ALBUM: option => {
    _track('TRACK_HEADER_ALBUM', { ...option })
  },

  // 트랙 유튜브 재생
  TRACK_YOUTUBE_PLAY: option => {
    _track('TRACK_YOUTUBE_PLAY', { ...option })
  },
  // 트랙 유튜브 중지
  TRACK_YOUTUBE_PAUSE: option => {
    _track('TRACK_YOUTUBE_PAUSE', { ...option })
  },
  // 트랙 유튜브 종료
  TRACK_YOUTUBE_END: option => {
    _track('TRACK_YOUTUBE_END', { ...option })
  },
  // 트랙 유튜브 에러
  TRACK_YOUTUBE_ERROR: option => {
    _track('TRACK_YOUTUBE_ERROR', { ...option })
  },
  // 트랙 유튜브 리스트 오른쪽 이동
  TRACK_YOUTUBE_LIST_RIGHT: option => {
    _track('TRACK_YOUTUBE_LIST_RIGHT', { ...option })
  },
  // 트랙 유튜브 리스트 왼쪽 이동
  TRACK_YOUTUBE_LIST_LEFT: option => {
    _track('TRACK_YOUTUBE_LIST_LEFT', { ...option })
  },

  // 트랙 스포티파이 링크 클릭
  TRACK_SPOTIFY_LINK_CLICK: option => {
    _track('TRACK_SPOTIFY_LINK_CLICK', { ...option })
  },
  // 트랙 멜론 링크 크릭
  TRACK_MELON_LINK_CLICK: option => {
    _track('TRACK_MELON_LINK_CLICK', { ...option })
  },
  // 트랙 유튜브뮤직 링크 클릭
  TRACK_YOUTUBE_MUSIC_LINK_CLICK: option => {
    _track('TRACK_YOUTUBE_MUSIC_LINK_CLICK', { ...option })
  },
  // 트랙 지니 링크 클릭
  TRACK_GENIE_LINK_CLICK: option => {
    _track('TRACK_GENIE_LINK_CLICK', { ...option })
  },
  // 트랙 벅스 링크 클릭
  TRACK_BUGS_LINK_CLICK: option => {
    _track('TRACK_BUGS_LINK_CLICK', { ...option })
  },
  // 트랙 바이브 링크 클릭
  TRACK_VIBE_LINK_CLICK: option => {
    _track('TRACK_VIBE_LINK_CLICK', { ...option })
  },
  // 트랙 플로 링크 클릭
  TRACK_FLO_LINK_CLICK: option => {
    _track('TRACK_FLO_LINK_CLICK', { ...option })
  },
  // 트랙 애플뮤직 링크 클릭
  TRACK_APPLE_MUSIC_LINK_CLICK: option => {
    _track('TRACK_APPLE_MUSIC_LINK_CLICK', { ...option })
  },
  // 트랙 아마존뮤직 링크 클릭
  TRACK_AMAZON_MUSIC_LINK_CLICK: option => {
    _track('TRACK_AMAZON_MUSIC_LINK_CLICK', { ...option })
  },
  // 트랙 타이달 링크 클릭
  TRACK_TIDAL_LINK_CLICK: option => {
    _track('TRACK_TIDAL_LINK_CLICK', { ...option })
  },
  // 트랙 디즈어 링크 클릭
  TRACK_DEEZER_LINK_CLICK: option => {
    _track('TRACK_DEEZER_LINK_CLICK', { ...option })
  },
  // 트랙 라인 링크 클릭
  TRACK_LINE_LINK_CLICK: option => {
    _track('TRACK_LINE_LINK_CLICK', { ...option })
  },
  // 트랙 가사 더보기
  TRACK_LYRICS_MORE: option => {
    _track('TRACK_LYRICS_MORE', { ...option })
  },
  // 트랙 댓글 더보기
  TRACK_COMMENT_MORE: option => {
    _track('TRACK_COMMENT_MORE', { ...option })
  },

  // 트랙 하단 홈 탭
  TRACK_HOME_TAB: option => {
    _track('TRACK_HOME_TAB', { ...option })
  },
  // 트랙 하단 듣기 탭
  TRACK_LISTEN_TAB: option => {
    _track('TRACK_LISTEN_TAB', { ...option })
  },
}

const _track = (label, params) => {
  // userId가 없으면 deviceId로 set
  console.log('[amplitudeEvent] getUserId:', amplitude.getUserId())
  if (!amplitude.getUserId()) {
    const deviceId = amplitude.getDeviceId()
    amplitude.setUserId(deviceId)
    console.log(
      '[amplitudeEvent] userId가 없어 deviceId로 setUserId:',
      deviceId,
    )
  }
  console.log('[amplitudeEvent]', label, params)

  if (process.env['NODE_ENV'] === 'development') {
    return
  }
  amplitude.track(label, params)
}
